import old from "../../images/questionIcons/Jordans-old.jpeg";
import newImg from "../../images/questionIcons/Jordans-new.jpeg";
import bigMacOld from "../../images/questionIcons/BigMac-old.jpeg";
import bigMacNew from "../../images/questionIcons/BigMac-new.jpeg";
import houseOld from "../../images/questionIcons/House-old.jpeg";
import houseNew from "../../images/questionIcons/House-new.jpeg";
import TVOld from "../../images/questionIcons/TV-old.jpeg";
import TVNew from "../../images/questionIcons/TV-new.jpeg";
import fordOld from "../../images/questionIcons/ford-old.jpeg";
import fordNew from "../../images/questionIcons/ford-new.jpeg";
import LEGOOld from "../../images/questionIcons/LEGO-old.jpeg";
import LEGONew from "../../images/questionIcons/LEGO-new.jpeg";
import ToothFairyOld from "../../images/questionIcons/Tooth-fairy-old.jpeg";
import ToothFairyNew from "../../images/questionIcons/Tooth-fairy-new.jpeg";
import UnderwearOld from "../../images/questionIcons/Underwear-old.jpeg";
import UnderwearNew from "../../images/questionIcons/Underwear-new.jpeg";
import InsulinOld from "../../images/questionIcons/Insulin-old.jpeg";
import InsulinNew from "../../images/questionIcons/Insulin-old.jpeg";
import survivorOld from "../../images/questionIcons/Survivor-old.jpg";
import survivorNew from "../../images/questionIcons/Survivor-new.jpg";
import Q1 from "../../images/G1.svg";
import Q2 from "../../images/G2.svg";
import Q3 from "../../images/G3.svg";
import Q4 from "../../images/G4.svg";
import Q5 from "../../images/G5.svg";
import Q6 from "../../images/G6.svg";
import Q7 from "../../images/G7.svg";
import Q8 from "../../images/G8.svg";
import Q9 from "../../images/G9.svg";
import Q10 from "../../images/G10.svg";

const questionSet = [
  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "AIR JORDANS",
    answer: 2, //2 mean new image selection is correct
    detailText:
      "$56.95 is $175.07 in 2026 dollars. Therefore, after adjusting for inflation, the 2026 Nike Air Jordan Highs are cheaper than Jordans from 1985 (although a genuine vintage pair of 1985 Jordans will set you back tens of thousands of dollars).",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), footlocker.com (new price)',
    old: {
      price: "56.95",
      year: 1985,
      cpi: 108,
      image: old,
    },
    new: {
      price: "149.99",
      year: 2026,
      cpi: 332,
      image: newImg,
    },
    equation: Q1,
    inflation: {
      price: "175.07",
      year: 2026,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "BIG MAC",
    answer: 1,
    detailText:
      "$0.49 is $4.65 in 2026 dollars. Therefore, after adjusting for inflation, the original Big Mac is cheaper than a Big Mac currently (although regional prices may vary). Food prices, in general, have remained fairly stable in the U.S. over the past 50 years, with some items increasing in price and others decreasing.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), Mac-menus.com (new price)',
    old: {
      price: "0.49",
      year: 1968,
      cpi: 35,
      image: bigMacOld,
    },
    new: {
      price: "6.72",
      year: 2026,
      cpi: 332,
      image: bigMacNew,
    },
    equation: Q2,
    inflation: {
      price: "4.65",
      year: 2026,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "LOS ANGELES HOUSE",
    answer: 1, //1 mean old image selection is correct
    detailText:
      "$43,500 is $225,895 in 2022 dollars. Therefore, after adjusting for inflation, the home has quadrupled in price (despite not being remodeled in 46 years!). This is not uncommon in America's most desirable cities—the supply of housing has not kept up with demand, causing prices to spiral upwards.",
    sourcesText: '<span style="color: #898989;">SOURCE:</span> Redfin.com',
    old: {
      price: "43,500",
      year: 1976,
      cpi: 57,
      image: houseOld,
    },
    new: {
      price: "911,963",
      year: 2022,
      cpi: 296,
      image: houseNew,
    },
    equation: Q3,
    inflation: {
      price: "225,895",
      year: 2022,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: '27" TELEVISION',
    answer: 2,
    detailText:
      "$279.95 is $3,442 in 2026 dollars. TVs today, despite being of much higher quality than those of the past, are actually far cheaper after adjusting for inflation. In fact, few goods have decreased in price more than TVs. This is primarily because of global competition and innovation.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), Bestbuy.com (new price)',
    old: {
      price: "279.95",
      year: 1953,
      cpi: 27,
      image: TVOld,
    },
    new: {
      price: "199.99",
      year: 2026,
      cpi: 332,
      image: TVNew,
    },
    equation: Q4,
    inflation: {
      price: "3,442",
      year: 2026,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "FORD SEDAN",
    answer: 2,
    detailText:
      "$850 is $24,461 in 2020 dollars. A Ford Model T was actually more expensive in 1909 than a far superior Ford Sedan in 2020 (the last year Ford sold sedans). Cars, in general, have held steady in price over time despite improving in both technology and comforts.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), Cars.com (new price)',
    old: {
      price: "850",
      year: 1909,
      cpi: 9,
      image: fordOld,
    },
    new: {
      price: "23,170",
      year: 2020,
      cpi: 259,
      image: fordNew,
    },
    equation: Q5,
    inflation: {
      price: "24,461",
      year: 2020,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "LEGO X-WING FIGHTER",
    answer: 1,
    detailText:
      "$30 is $59.64 in 2026 dollars, so the Lego from 1999 is cheaper. However, the current Lego is larger and contains roughly double the Lego bricks. On a price per piece basis, the 1999 X Wing (263 pieces) cost 22.7 cents per lego piece (after adjusting for inflation) while the 2026 X wing (558 pieces) cost 12.5 cents per piece. In general, toys have had one of the most significant drops in price since 1999, with an average drop of over 50% in price for other toys.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), Lego.com (new price)',
    old: {
      price: "30",
      year: 1999,
      cpi: 167,
      image: LEGOOld,
    },
    new: {
      price: "69.99",
      year: 2026,
      cpi: 332,
      image: LEGONew,
    },
    equation: Q6,
    inflation: {
      price: "59.64",
      year: 2026,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "TOOTH FAIRY (average tooth price)",
    answer: 1,
    detailText:
      "$1.60 is $3.00 in 2026 dollars. That means the amount the tooth fairy gives out has increased by more than $2 since 2001. Taken in conjunction with drops in toy prices, the purchasing power of kids has greatly expanded over the previous two decades.",
    sourcesText:
      '<span style="color: #898989;">SOURCE:</span> <a style="color: #898989" target="_blank" href="https://www.deltadental.com/tooth-fairy/press-release/#2026">Delta Dental Poll</a>',
    old: {
      price: "1.60",
      year: 2001,
      cpi: 177,
      image: ToothFairyOld,
    },
    new: {
      price: "5.84",
      year: 2026,
      cpi: 332,
      image: ToothFairyNew,
    },
    equation: Q7,
    inflation: {
      price: "3.00",
      year: 2026,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "UNDERWEAR",
    answer: 2,
    detailText:
      "$1.00 is $13.83 in 2026 dollars. Underwear, like most clothing, has gone down in price over time.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), Walmart.com (new price)',
    old: {
      price: "1.00",
      year: 1949,
      cpi: 24,
      image: UnderwearOld,
    },
    new: {
      price: "2.50",
      year: 2026,
      cpi: 332,
      image: UnderwearNew,
    },
    equation: Q8,
    inflation: {
      price: "13.83",
      year: 2026,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "LONG ACTING INSULIN (per unit)",
    answer: 1,
    detailText:
      "$0.05 is $0.09 in 2024 dollars, so insulin in 2024 cost more than in 2001.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> <a style="color: #898989" target="_blank" href="https://www.goodrx.com/healthcare-access/research/how-much-does-insulin-cost-compare-brands">Goodrx.com</a>',
    old: {
      price: "0.05",
      year: 2001,
      cpi: 177,
      image: InsulinOld,
    },
    new: {
      price: "0.19",
      year: 2024,
      cpi: 314,
      image: InsulinNew,
    },
    equation: Q9,
    inflation: {
      price: "0.09",
      year: 2024,
    },
  },

  {
    title: "Adjusting for inflation, which is worth <u>MORE</u>?",
    subTitle: "SURVIVOR PRIZE MONEY",
    answer: 2,
    winnerLabel: "Worth less",
    detailText:
      "$1 million from 2000 is worth $1.9 million in 2026 dollars, which means the 50th Survivor prize is worth more (before taxes). However, the prize money for the 50th season doubled due to a special coin flip. Originally the payout would have been $1 million, which today has a far lower purchasing power than in 2000.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> <a style="color: #898989" target="_blank" href="https://www.forbes.com/sites/nathangoldman/2026/05/20/survivor-50s-2-million-prize-comes-with-a-massive-tax-bill/">Forbes.com</a>',
    old: {
      price: "1,000,000",
      year: 2000,
      cpi: 172,
      image: survivorOld,
    },
    new: {
      price: "2,000,000",
      year: 2026,
      cpi: 332,
      image: survivorNew,
    },
    equation: Q10,
    inflation: {
      price: "1,930,233",
      year: 2026,
    },
  },
];

export default questionSet;
